import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { EventHandler } from "../../util/event/EventHandler";
/*
 * FileRequest.ts
 */
export class FileRequest {
    constructor(url) {
        this.url = url;
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_XML);
        this.request.setResponseType(RequestConstants.TEXT);
        this.request.onComplete(this.handleConfigComplete, this);
        this.request.onError(this.handleConfigError, this);
        this.request.send();
    }
    handleConfigComplete() {
        this.completeHandler.call(this);
    }
    handleConfigError() {
        this.completeHandler.call(this);
    }
    getResponseText() {
        return this.request.getRequest().responseText;
    }
}
//# sourceMappingURL=FileRequest.js.map